import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import { useChipiContext } from "../context";
import type { StakeVesuUsdcParams, StakeVesuUsdcHookInputParams } from "@chipi-stack/types";

type StakeVesuUsdcInput = {
  params: StakeVesuUsdcHookInputParams;
  bearerToken: string;
};

/**
 * Hook for staking USDC in Vesu protocol
 */
export function useStakeVesuUsdc(): {
  stakeVesuUsdc: (params: StakeVesuUsdcInput) => void;
  stakeVesuUsdcAsync: (params: StakeVesuUsdcInput) => Promise<string>;
  data: string | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  isSuccess: boolean;
  reset: () => void;
} {
  const { chipiSDK } = useChipiContext();

  const mutation: UseMutationResult<string, Error, StakeVesuUsdcInput> =
    useMutation({
      mutationFn: (params: StakeVesuUsdcInput) =>
        chipiSDK.stakeVesuUsdc({
          params: {
            ...params.params,
            amount: String(params.params.amount),
          },
          bearerToken: params.bearerToken,
        }),
    });

  return {
    stakeVesuUsdc: mutation.mutate,
    stakeVesuUsdcAsync: mutation.mutateAsync,
    data: mutation.data,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
}
